import React from 'react';
import { useTranslation } from 'next-i18next';
import { ChevronDown } from 'lucide-react';
import { Accordion, AccordionItem, AccordionTrigger, AccordionContent, Card } from '@gu-corp/gu-ui';

const HowLendingWorks = () => {
  const { t } = useTranslation('common');

  const steps = [
    {
      number: 1,
      title: t('lending_page.how_it_works_step_1_title'),
      description: t('lending_page.how_it_works_step_1_description'),
    },
    {
      number: 2,
      title: t('lending_page.how_it_works_step_2_title'),
      description: t('lending_page.how_it_works_step_2_description'),
    },
    {
      number: 3,
      title: t('lending_page.how_it_works_step_3_title'),
      description: t('lending_page.how_it_works_step_3_description'),
    },
  ];

  return (
    <Card className="p-0 overflow-hidden">
      <Accordion type="single" collapsible defaultValue="how-it-works">
        <AccordionItem value="how-it-works" className="border-0">
          <AccordionTrigger
            className="px-6 py-4 hover:no-underline"
            data-testid="how-lending-works-accordion"
          >
            <span className="text-lg font-semibold" data-testid="how-lending-works-title">
              {t('lending_page.how_it_works_title')}
            </span>
          </AccordionTrigger>
          <AccordionContent className="px-6 pb-6">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              {steps.map((step) => (
                <div key={step.number} className="flex flex-col">
                  <div className="flex items-center gap-3 mb-2">
                    <div className="w-8 h-8 rounded-full bg-primary text-primary-foreground flex items-center justify-center text-sm font-semibold">
                      {step.number}
                    </div>
                    <span className="font-medium text-foreground">{step.title}</span>
                  </div>
                  <p
                    className="text-sm text-muted-foreground pl-11"
                    data-testid={`lending-step-${step.number}-description`}
                  >
                    {step.description}
                  </p>
                </div>
              ))}
            </div>
          </AccordionContent>
        </AccordionItem>
      </Accordion>
    </Card>
  );
};

export default HowLendingWorks;
